import type { Plan, TemplateCategory } from "@/types/database";

export { cn } from "@/lib/utils";

export const APP_NAME = "WeddInv";
export const APP_DESCRIPTION = "Создайте красивый свадебный сайт за несколько минут";
export const APP_URL = "https://app.weddinv.ru";

export const ROUTES = {
  HOME: "/lending",
  LOGIN: "/login",
  REGISTER: "/register",
  DASHBOARD: "/dashboard",
  PROJECTS: "/dashboard/projects",
  CREATE: "/dashboard/create",
  EDITOR: "/dashboard/editor",
  GUESTS: "/dashboard/guests",
  FILES: "/dashboard/files",
  DOMAINS: "/dashboard/domains",
  SETTINGS: "/dashboard/settings",
  PROFILE: "/dashboard/profile",
  BILLING: "/dashboard/billing",
  SUPPORT: "/dashboard/support",
  TEMPLATES: "/templates",
  PRICING: "/pricing",
  ADMIN: "/admin",
  RSVP: "/rsvp",
  PARTNERS: "/partners",
} as const;

export const TEMPLATE_CATEGORIES: TemplateCategory[] = [
  { id: "1", slug: "romantic", name: "Romantic", sort_order: 1, created_at: "" },
  { id: "2", slug: "minimal", name: "Minimal", sort_order: 2, created_at: "" },
  { id: "3", slug: "classic", name: "Classic", sort_order: 3, created_at: "" },
  { id: "4", slug: "luxury", name: "Luxury", sort_order: 4, created_at: "" },
  { id: "5", slug: "italian", name: "Italian", sort_order: 5, created_at: "" },
  { id: "6", slug: "french", name: "French", sort_order: 6, created_at: "" },
  { id: "7", slug: "boho", name: "Boho", sort_order: 7, created_at: "" },
  { id: "8", slug: "editorial", name: "Editorial", sort_order: 8, created_at: "" },
  { id: "9", slug: "flowers", name: "Flowers", sort_order: 9, created_at: "" },
  { id: "10", slug: "dark", name: "Dark", sort_order: 10, created_at: "" },
  { id: "11", slug: "elegant", name: "Elegant", sort_order: 11, created_at: "" },
  { id: "12", slug: "modern", name: "Modern", sort_order: 12, created_at: "" },
  { id: "13", slug: "vintage", name: "Vintage", sort_order: 13, created_at: "" },
  { id: "14", slug: "garden", name: "Garden", sort_order: 14, created_at: "" },
  { id: "15", slug: "olive", name: "Olive", sort_order: 15, created_at: "" },
  { id: "16", slug: "watercolor", name: "Watercolor", sort_order: 16, created_at: "" },
  { id: "17", slug: "pastel", name: "Pastel", sort_order: 17, created_at: "" },
  { id: "18", slug: "white", name: "White", sort_order: 18, created_at: "" },
  { id: "19", slug: "champagne", name: "Champagne", sort_order: 19, created_at: "" },
  {
    id: "20",
    slug: "toile-de-jouy",
    name: "Toile de Jouy",
    sort_order: 20,
    created_at: "",
  },
];

export const PLANS: Plan[] = [
  {
    id: "free",
    name: "Free",
    price: 0,
    period: "month",
    cta: "Начать бесплатно",
    features: [
      { text: "1 сайт", included: true },
      { text: "До 10 гостей", included: true },
      { text: "Базовые шаблоны", included: true },
      { text: "Поддомен WeddInv", included: true },
      { text: "RSVP", included: false },
      { text: "Собственный домен", included: false },
      { text: "Видео", included: false },
      { text: "Убрать брендинг", included: false },
    ],
  },
  {
    id: "start",
    name: "Start",
    price: 490,
    period: "month",
    cta: "Выбрать Start",
    features: [
      { text: "1 сайт", included: true },
      { text: "Все шаблоны", included: true },
      { text: "Пользовательский slug", included: true },
      { text: "Безлимитные гости", included: true },
      { text: "RSVP + Статистика", included: true },
      { text: "Убрать брендинг WeddInv", included: true },
      { text: "Собственный домен", included: false },
      { text: "Видео", included: false },
    ],
  },
  {
    id: "premium",
    name: "Premium",
    price: 990,
    period: "month",
    is_popular: true,
    cta: "Выбрать Premium",
    features: [
      { text: "3 сайта", included: true },
      { text: "Все шаблоны", included: true },
      { text: "Собственный домен", included: true },
      { text: "SSL включен", included: true },
      { text: "Видео", included: true },
      { text: "Библиотека музыки", included: true },
      { text: "Продвинутая аналитика", included: true },
      { text: "Приоритетная поддержка", included: true },
    ],
  },
  {
    id: "business",
    name: "Business",
    price: 2490,
    period: "month",
    cta: "Выбрать Business",
    features: [
      { text: "10 сайтов", included: true },
      { text: "Все функции Premium", included: true },
      { text: "Белая метка (White-label)", included: true },
      { text: "Свой домен для каждого сайта", included: true },
      { text: "API доступ", included: true },
      { text: "Командная работа", included: true },
      { text: "Экспорт данных", included: true },
      { text: "Выделенная поддержка", included: true },
    ],
  },
  {
    id: "agency",
    name: "Agency",
    price: 4990,
    period: "month",
    cta: "Выбрать Agency",
    features: [
      { text: "Безлимитные сайты", included: true },
      { text: "Все функции Business", included: true },
      { text: "Управление клиентами", included: true },
      { text: "Кастомный брендинг", included: true },
      { text: "Комиссионная система", included: true },
      { text: "Персональный менеджер", included: true },
      { text: "SLA", included: true },
      { text: "Приоритетная поддержка 24/7", included: true },
    ],
  },
];

export const BLOCK_TYPES = [
  { id: "countdown", name: "Таймер обратного отсчёта", icon: "Timer" },
  { id: "love_story", name: "Love Story", icon: "Heart" },
  { id: "gallery", name: "Галерея", icon: "Images" },
  { id: "rsvp", name: "RSVP", icon: "ClipboardCheck" },
  { id: "map", name: "Карта", icon: "MapPin" },
  { id: "route", name: "Маршрут", icon: "Route" },
  { id: "dress_code", name: "Дресс-код", icon: "Shirt" },
  { id: "palette", name: "Цветовая палитра", icon: "Palette" },
  { id: "gifts", name: "Подарки", icon: "Gift" },
  { id: "qr_gift", name: "QR-код для подарка", icon: "QrCode" },
  { id: "bank_details", name: "Банковские реквизиты", icon: "CreditCard" },
  { id: "children", name: "Дети на свадьбе", icon: "Baby" },
  { id: "faq", name: "FAQ", icon: "HelpCircle" },
  { id: "timeline", name: "Тайминг дня", icon: "Clock" },
  { id: "menu", name: "Меню", icon: "UtensilsCrossed" },
  { id: "contacts", name: "Контакты", icon: "Phone" },
  { id: "bridesmaids", name: "Подружки невесты", icon: "Users" },
  { id: "groomsmen", name: "Друзья жениха", icon: "Users" },
  { id: "host", name: "Ведущий", icon: "Mic" },
  { id: "organizer", name: "Организатор", icon: "Calendar" },
  { id: "photographer", name: "Фотограф", icon: "Camera" },
  { id: "videographer", name: "Видеограф", icon: "Video" },
  { id: "seating", name: "Размещение гостей", icon: "LayoutGrid" },
  { id: "hotels", name: "Отели", icon: "Building" },
  { id: "transport", name: "Трансфер", icon: "Car" },
  { id: "pinterest", name: "Pinterest", icon: "Bookmark" },
  { id: "instagram", name: "Instagram", icon: "Instagram" },
  { id: "telegram", name: "Telegram", icon: "Send" },
  { id: "whatsapp", name: "WhatsApp", icon: "MessageCircle" },
];

export const FONTS = {
  heading: [
    "Mirra",
    "Cormorant Garamond",
    "Playfair Display",
    "EB Garamond",
    "Great Vibes",
    "Cormorant",
  ],
  body: [
    "Jost",
    "Inter",
    "Georgia",
    "Cormorant Garamond",
  ],
};

export const COLOR_PRESETS = [
  {
    name: "Cream Gold (Maket 15)",
    primary: "#9E7F52",
    secondary: "#E1D5C1",
    accent: "#69482e",
    background: "#F5F0EB",
    text: "#69482e",
  },
  {
    name: "White Classic (Maket 1)",
    primary: "#555050",
    secondary: "#F5F0EB",
    accent: "#000000",
    background: "#FFFFFF",
    text: "#000000",
  },
  {
    name: "Olive (Maket 3)",
    primary: "#526648",
    secondary: "#DDDACC",
    accent: "#000000",
    background: "#DDDACC",
    text: "#000000",
  },
  {
    name: "Burgundy (Maket 4)",
    primary: "#9F835C",
    secondary: "#F2EADF",
    accent: "#9C0000",
    background: "#F9F5EF",
    text: "#000000",
  },
  {
    name: "Classic Gold",
    primary: "#C9A96E",
    secondary: "#F5E6E0",
    accent: "#B76E79",
    background: "#FAF8F5",
    text: "#2C1810",
  },
  {
    name: "Dusty Rose",
    primary: "#D4A5A5",
    secondary: "#F5E6E0",
    accent: "#9B6B6B",
    background: "#FDF8F6",
    text: "#3D2B2B",
  },
  {
    name: "Sage Green",
    primary: "#8FA68A",
    secondary: "#E8F0E6",
    accent: "#5C7A58",
    background: "#F8FAF7",
    text: "#2C3E2C",
  },
  {
    name: "Navy & Gold",
    primary: "#C9A96E",
    secondary: "#E8E4DF",
    accent: "#1E3A5F",
    background: "#FAFAF8",
    text: "#1E2D3D",
  },
  {
    name: "Terracotta",
    primary: "#C4725A",
    secondary: "#F5E6E0",
    accent: "#8B4D3A",
    background: "#FDF8F5",
    text: "#3D2420",
  },
  {
    name: "Midnight",
    primary: "#C9A96E",
    secondary: "#2C2C3A",
    accent: "#E8D5A3",
    background: "#1A1A24",
    text: "#F0ECE6",
  },
];

export const ANIMATION_VARIANTS = {
  fadeIn: {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 0.6 } },
  },
  slideUp: {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] },
    },
  },
  slideDown: {
    hidden: { opacity: 0, y: -20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.4, ease: "easeOut" },
    },
  },
  scaleIn: {
    hidden: { opacity: 0, scale: 0.95 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.3, ease: "easeOut" },
    },
  },
  staggerContainer: {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1, delayChildren: 0.2 },
    },
  },
  staggerItem: {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] },
    },
  },
};
